import script from "./AddAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAddress.vue?vue&type=script&setup=true&lang=js"

import "./AddAddress.vue?vue&type=style&index=0&id=6c80cd7f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c80cd7f"]])

export default __exports__